var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.1673H1.99996V2.16732H14M14 0.833984H1.99996C1.25996 0.833984 0.666626 1.42732 0.666626 2.16732V10.1673C0.666626 10.5209 0.807102 10.8601 1.05715 11.1101C1.3072 11.3602 1.64634 11.5007 1.99996 11.5007H6.66663V12.834H5.33329V14.1673H10.6666V12.834H9.33329V11.5007H14C14.3536 11.5007 14.6927 11.3602 14.9428 11.1101C15.1928 10.8601 15.3333 10.5209 15.3333 10.1673V2.16732C15.3333 1.42732 14.7333 0.833984 14 0.833984Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMonitor);
export default __webpack_public_path__ + "static/media/icon-monitor.a06e1d6ad1de3e50339697455d4f0853.svg";
export { ForwardRef as ReactComponent };